import { useParams } from "react-router-dom";
import { useSeo } from "@/lib/seo";

const CONTENT = {
    privacy: {
        title: "Privacy Policy",
        body: "SUDIGI respects your privacy. We collect only the information necessary to provide our services — such as your name, contact details and business information — and use it to deliver and improve our digital marketing services. We do not sell your personal data. We store lead and order information securely and share it only with the team members working on your project. You may request access to or deletion of your data by contacting info@sudigi.in.",
    },
    terms: {
        title: "Terms & Conditions",
        body: "By using SUDIGI's website and services you agree to these terms. Services are delivered as described in the selected service or package. Prices are shown exclusive of GST unless stated otherwise. We do not promise guaranteed rankings, leads or sales — we commit to transparent deliverables and professional execution. Timelines depend on the scope agreed with your Business Development Executive. Payments are processed securely via our payment gateway partner.",
    },
    refund: {
        title: "Refund Policy",
        body: "Refund eligibility depends on the service and the stage of execution. If work has not yet started on your order, you may request a refund by contacting info@sudigi.in. Once execution has begun, refunds are considered on a pro-rata basis for work not yet delivered. Monthly package fees are non-refundable for the current billing cycle once the service period has started. For any refund query, please reach out to your BDE or our support team.",
    },
};

export default function Legal() {
    const { kind } = useParams();
    const c = CONTENT[kind] || CONTENT.privacy;
    useSeo({ title: `${c.title} | SUDIGI`, description: c.title });
    return (
        <section className="bg-teal-900 py-16 min-h-[70vh]">
            <div className="container-x max-w-3xl">
                <h1 className="font-serif text-4xl text-cream mb-6">{c.title}</h1>
                <p className="text-cream-soft leading-relaxed">{c.body}</p>
            </div>
        </section>
    );
}
